import {RestResource} from '../rest'

import {ASSET_SERVER} from '../server'

const asset = new RestResource({server: ASSET_SERVER, resource: 'asset'});

export default asset;
